import { render, staticRenderFns } from "./geneVariationDrugs.vue?vue&type=template&id=168b2118&scoped=true"
import script from "./geneVariationDrugs.vue?vue&type=script&lang=js"
export * from "./geneVariationDrugs.vue?vue&type=script&lang=js"
import style0 from "./geneVariationDrugs.vue?vue&type=style&index=0&id=168b2118&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "168b2118",
  null
  
)

export default component.exports